import firebase from 'firebase/app'
import 'firebase/firestore';

export default {
  fetchCardapio({
    dispatch,
    commit
  }, data) {
    return new Promise((resolve, reject) => {

      // Reference do Firebase para uso das 3 chamadas das COLLECTIONS abaixo (tipo-cardapio, categorias e produtos)
      const ref = firebase
        .firestore()
        .collection("estabelecimentos")
        .doc(data.estabelecimentoId);

      // Retorna Legenda dos itens de cada produto por tipo de cardápio
      let configuracoes = {}
      let legendaItens = ""

      ref
        .collection("tipos-cardapio")
        .doc(data.tipoCardapio)
        .get()
        .then(docTC => {
          if (!docTC.empty) {
            if (docTC.data().configuracoes) {
              configuracoes = docTC.data().configuracoes;

              if (docTC.data().configuracoes.legendaItens) legendaItens = docTC.data().configuracoes.legendaItens

              if (docTC.data().configuracoes.filtrarPais) dispatch('fetchPaises')
            }
          }
        })
        .catch((error) => {
          reject(error)
        })

      // Retorna as categorias
      const tiposCardapios = {}

      ref
        .collection("categorias")
        .orderBy("ordenar")
        .where("tipo-cardapio", "==", data.tipoCardapio)
        .where("ativo", "==", true)
        .where("removido", "==", false)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {

            const categorias = []

            snapshot.forEach(doc => {

              // Retorna os produtos de cada categoria
              const produtos = []

              ref
                .collection("categorias")
                .doc(doc.id)
                .collection("produtos")
                .where("ativo", "==", true)
                .where("removido", "==", false)
                .get()
                .then(snapshotP => {
                  snapshotP.forEach(docP => {

                    // Retorna legenda "A partir de" nos produtos que contém itens
                    ref
                      .collection("categorias").doc(doc.id).collection("produtos")
                      .doc(docP.id).collection("itens").limit(1).get()
                      .then(snapshotItens => {
                        let legendaPrecoAPartir = null
                        if (!snapshotItens.empty) legendaPrecoAPartir = "A partir de"

                        // Retorna pais caso seja uma carta de vinhos
                        const paisData = {
                          nome: null,
                          icone: null
                        };

                        if (docP.data().paisReference) {
                          docP.data().paisReference.get()
                            .then(res => {
                              paisData.nome = res.data().nome;
                              paisData.icone = res.data().icone;
                            });
                        }

                        // Push nos produtos
                        produtos.push({
                          id: docP.id,
                          nome: docP.data().nome,
                          descricao: docP.data().descricao,
                          imagem: docP.data().imagem,
                          preco: docP.data().preco,
                          ordenar: docP.data().ordenar,
                          legendaItens: legendaItens,
                          legendaPrecoAPartir: legendaPrecoAPartir,
                          pais: paisData,
                          estabelecimentoId: data.estabelecimentoId,
                          categoriaId: doc.id
                        });
                      })
                  });
                })
                .catch((error) => {
                  reject(error)
                })

              categorias.push({
                categoriaNome: doc.data().nome,
                produtos: produtos
              });

            });

            tiposCardapios.categorias = categorias
            tiposCardapios.tipoCardapio = data.tipoCardapio
            tiposCardapios.configuracoes = configuracoes

            commit('SET_CARDAPIO', tiposCardapios)
            resolve(snapshot)
          }
        })
        .catch((error) => {
          reject(error)
        })

    })
  },

  fetchPaises({
    commit
  }) {
    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection("paises")
        .orderBy("nome")
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            const paises = []
            paises.push({
              id: 0,
              nome: "Filtrar por País"
            }, {
              id: 0,
              nome: "TODOS"
            });
            snapshot.forEach(doc => {
              paises.push({
                id: doc.id,
                nome: doc.data().nome
              });
            });

            commit('SET_PAISES', paises)
            resolve(snapshot)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}